import axios, { AxiosInstance, AxiosResp, AxiosResponse } from "axios";
import { useStore } from "@/store";
import NProgress, { remove, set } from "nprogress";
import router from "@/router";
import { StandardResponse } from "@/types";

const axiosTimeout = 10000,
  axiosTimeoutTest = 20000;

NProgress.configure({
  easing: "ease", // 动画方式
  minimum: 0.3, // 启动时使用的最小百分比
  parent: ".process-parent", //指定进度条的父容器
  trickle: false, // 启动后不自动增长
  showSpinner: false, // 关闭旋转加载图标
});

const nprocess = {
  start: () => {
    NProgress.start();
  },
  done: () => {
    NProgress.done();
  },
  inc: () => {
    NProgress.inc();
  },
  setProcess: function () {
    const store = useStore();
    if (store.axiosConnections === 0) {
      this.start();
    }
    store.establishConnection();
  },
  doneProcess: function () {
    const store = useStore();
    store.finishConnection();
    if (!location.pathname.startsWith("/winpost")) {
      if (store.axiosConnections === 0) {
        this.done();
      } else {
        this.inc();
      }
    }
  },
};

const axiosRespProcess: (
  response: AxiosResponse<StandardResponse>
) => AxiosResp = (response: AxiosResponse<StandardResponse>) => {
  try {
    const resp = response as AxiosResp;
    resp.code = response.data.status;
    if (response.data.status == 0) {
      resp.msg = response.data.message;
      resp.data = response.data.data;
      // response.data = response.data.data;
      return resp;
    } else if (response.data.status == 1) {
      window.$message.error("未登录或认证失败，请重新登录");
      console.error("未登录或认证失败，请重新登录", response.data);
      resp.data = response.data.data;
      resp.status = 403;
      // response.data = response.data.data;
      // response.status = 403;
      router.push("/login");

      return resp;
    } else if (response.data.status == 2) {
      console.error("发生错误：", response.data);
      // response.data = response.data.data;
      // response.status = 500;
      resp.msg = response.data.message;
      resp.data = response.data.data;
      resp.status = 500;
      return resp;
    } else if (response.data.status == 3) {
      window.$notifyError("请求失败 BAD REQUEST: ", response.data.message);
      console.error("请求参数错误", response.data);
      resp.msg = response.data.message;
      resp.status = 400;
      resp.data = response.data.data;
      return resp;
    } else {
      resp.msg = "No message";
      resp.code = 0;
      return resp;
    }
  } catch (e) {
    console.error("axiosRespProcess error", e);
    window.$notifyError(
      "axiosRespProcess Error",
      "请求服务器返回结果处理错误，可能是网络连接有问题？"
    );
    return response as AxiosResp;
  }
};

// const axiosInstance = axios.create({
//     baseURL: "http://localhost:8081/consoleapi", // 全局的 baseURL
//     timeout: axiosTimeoutTest, // 请求超时时间
//   }),
//   axiosInstanceWithoutMask = axios.create({
//     baseURL: "http://localhost:8081/consoleapi",
//     timeout: axiosTimeoutTest,
//   }),
//   axiosBaseInstance = axios.create({
//     baseURL: `http://localhost:8080/`,
//     timeout: axiosTimeoutTest,
//   }),
//   axiosBaseInstanceWithoutMask = axios.create({
//     baseURL: `http://localhost:8080/`,
//     timeout: axiosTimeoutTest,
//   }),
//   // 以下请求示例待添加拦截器
//   axiosInstanceWithSmallLoad = axios.create({
//     baseURL: "http://localhost:8081/consoleapi",
//     timeout: axiosTimeoutTest,
//   });
// const axiosInstance = axios.create({
//     baseURL: "/consoleapi", // 全局的 baseURL
//     timeout: axiosTimeoutTest, // 请求超时时间
//   }),
//   axiosInstanceWithoutMask = axios.create({
//     baseURL: "/consoleapi",
//     timeout: axiosTimeoutTest,
//   }),
//   axiosBaseInstance = axios.create({
//     baseURL: `/`,
//     timeout: axiosTimeoutTest,
//   }),
//   axiosBaseInstanceWithoutMask = axios.create({
//     baseURL: `/`,
//     timeout: axiosTimeoutTest,
//   }),
//   // 以下请求示例待添加拦截器
//   axiosInstanceWithSmallLoad = axios.create({
//     baseURL: "/consoleapi",
//     timeout: axiosTimeoutTest,
//   });

let axiosInstance: AxiosInstance,
  axiosInstanceWithoutMask: AxiosInstance,
  axiosBaseInstance: AxiosInstance,
  axiosBaseInstanceWithoutMask: AxiosInstance,
  axiosInstanceWithSmallLoad: AxiosInstance;

if (process.env.NODE_ENV === "production") {
  axiosInstance = axios.create({
    baseURL: "/consoleapi",
    timeout: axiosTimeout,
  });
  axiosInstanceWithoutMask = axios.create({
    baseURL: "/consoleapi",
    timeout: axiosTimeout,
  });
  axiosBaseInstance = axios.create({
    baseURL: "/",
    timeout: axiosTimeout,
  });
  axiosBaseInstanceWithoutMask = axios.create({
    baseURL: "/",
    timeout: axiosTimeout,
  });
  axiosInstanceWithSmallLoad = axios.create({
    baseURL: "/consoleapi",
    timeout: axiosTimeout,
  });
} else if (process.env.NODE_ENV === "development") {
  axiosInstance = axios.create({
    baseURL: "http://localhost:8082/consoleapi",
    timeout: axiosTimeout,
  });
  axiosInstanceWithoutMask = axios.create({
    baseURL: "http://localhost:8082/consoleapi",
    timeout: axiosTimeout,
  });
  axiosBaseInstance = axios.create({
    baseURL: "http://localhost:8080/",
    timeout: axiosTimeout,
  });
  axiosBaseInstanceWithoutMask = axios.create({
    baseURL: "http://localhost:8080/",
    timeout: axiosTimeout,
  });
  axiosInstanceWithSmallLoad = axios.create({
    baseURL: "http://localhost:8082/consoleapi",
    timeout: axiosTimeout,
  });
} else {
  throw new Error("Unsupported NODE_ENV: " + process.env.NODE_ENV);
}

const AxiosMap: Record<string, AxiosInstance> = {
  axiosInstance,
  axiosInstanceWithoutMask,
  axiosBaseInstance,
  axiosBaseInstanceWithoutMask,
  axiosInstanceWithSmallLoad,
};

// NGINX 反代配置，将 domain.com/consoleapi/ 转发到原来的端口
// const axiosInstance = axios.create({
//     baseURL: "/consoleapi",
//     timeout: axiosTimeout, // 请求超时时间
//   }),
//   axiosInstanceWithoutMask = axios.create({
//     baseURL: "/consoleapi",
//     timeout: axiosTimeout,
//   }),
//   axiosBaseInstance = axios.create({
//     baseURL: "/",
//     timeout: axiosTimeout,
//   }),
//   axiosBaseInstanceWithoutMask = axios.create({
//     baseURL: "/",
//     timeout: axiosTimeout,
//   }),
//   axiosInstanceWithSmallLoad = axios.create({
//     baseURL: "/consoleapi",
//     timeout: axiosTimeout,
//   });

axiosInstance.interceptors.request.use(
  (config) => {
    nprocess.setProcess();
    config.withCredentials = true;
    config.headers.Authorization = "console";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  (response) => {
    nprocess.doneProcess();
    return axiosRespProcess(response);
  },
  (error) => {
    const store = useStore();
    nprocess.doneProcess();
    if (error.status === 429) {
      store.sendTooManyRequest();
    } else {
      store.sendRequestFailed();
    }
    error.response = axiosRespProcess(error.response);
    return Promise.reject(error);
  }
);
axiosInstanceWithoutMask.interceptors.request.use(
  (config) => {
    config.withCredentials = true;
    config.headers.Authorization = "console";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosInstanceWithoutMask.interceptors.response.use(
  (response) => {
    return axiosRespProcess(response);
  },
  (error) => {
    const store = useStore();
    if (error.status === 429) {
      store.sendTooManyRequest();
    } else {
      store.sendRequestFailed();
    }
    error.response = axiosRespProcess(error.response);
    return Promise.reject(error);
  }
);
axiosBaseInstance.interceptors.request.use(
  (config) => {
    nprocess.setProcess();
    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosBaseInstance.interceptors.response.use(
  (response) => {
    nprocess.doneProcess();
    return axiosRespProcess(response);
  },
  (error) => {
    const store = useStore();
    nprocess.doneProcess();
    if (error.status === 429) {
      store.sendTooManyRequest();
    } else {
      store.sendRequestFailed();
    }
    error.response = axiosRespProcess(error.response);
    return Promise.reject(error);
  }
);
axiosBaseInstanceWithoutMask.interceptors.response.use(
  (response) => {
    return axiosRespProcess(response);
  },
  (error) => {
    const store = useStore();
    if (error.status === 429) {
      store.sendTooManyRequest();
    } else {
      store.sendRequestFailed();
    }
    error.response = axiosRespProcess(error.response);
    return Promise.reject(error);
  }
);
axiosInstanceWithSmallLoad.interceptors.request.use(
  (config) => {
    config.withCredentials = true;
    const store = useStore();
    store.establishSmallLoadConnection();
    config.headers.Authorization = "console";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosInstanceWithSmallLoad.interceptors.response.use(
  (response) => {
    const store = useStore();
    store.finishSmallLoadConnection();
    return axiosRespProcess(response);
  },
  (error) => {
    const store = useStore();
    store.finishSmallLoadConnection();
    if (error.status === 429) {
      store.sendTooManyRequest();
    } else {
      store.sendRequestFailed();
    }
    error.response = axiosRespProcess(error.response);
    return Promise.reject(error);
  }
);

// 登陆成功返回 Promise true，失败返回 Promise false0
const login = async (authKey: string): Promise<boolean> => {
  if (!authKey) return false;
  const formData = new FormData();
  formData.append("authKey", btoa(authKey));
  const res = await axiosInstance.post("/login", formData, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

  console.log("login res", res);
  if (res.data === "success") {
    console.log("login success");
    const store = useStore();
    store.setLoginAuthentication(authKey);
    return true;
  } else {
    console.log(res.data);
    return false;
  }
};

// 定义重载的函数类型
type QuickPostFunction = {
  (url: string, data: FormData): Promise<AxiosResp>;
  (url: string, data: Record<string, any>): Promise<AxiosResp>;
};
const quickPostBase = function (axiosinstanceName: string) {
  return ((url: string, data: FormData | Record<string, any>) => {
    if (!(data instanceof FormData)) {
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (value instanceof File) {
          // 如果是文件类型，直接添加
          formData.append(key, value);
        } else if (Array.isArray(value) || value instanceof Object) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, String(value));
        }
      });
      data = formData;
    }
    return AxiosMap[axiosinstanceName].post(url, data, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }) as QuickPostFunction;
};
// const quickAxiosInstancePost: QuickPostFunction = async function (
//   url: string,
//   data: FormData | Record<string, any>
// ) {
//   if (!(data instanceof FormData)) {
//     const formData = new FormData();
//     Object.entries(data).forEach(([key, value]) => {
//       formData.append(key, String(value));
//     });
//     data = formData;
//   }
//   return axiosInstance.post(url, data, {
//     headers: {
//       "Content-Type": "application/x-www-form-urlencoded",
//     },
//   });
// };
// const quickAxiosInstanceWithoutMaskPost: QuickPostFunction = async function (
//   url: string,
//   formData: FormData | Record<string, any>
// ) {
//   return axiosInstanceWithoutMask.post(url, formData, {
//     headers: {
//       "Content-Type": "application/x-www-form-urlencoded",
//     },
//   });
// };
// const quickAxiosBaseInstancePost: QuickPostFunction = async function (
//   url: string,
//   formData: FormData | Record<string, any>
// ) {
//   return axiosBaseInstance.post(url, formData, {
//     headers: {
//       "Content-Type": "application/x-www-form-urlencoded",
//     },
//   });
// };
// const quickAxiosBaseInstanceWithoutMaskPost: QuickPostFunction =
//   async function (url: string, formData: FormData | Record<string, any>) {
//     return axiosBaseInstanceWithoutMask.post(url, formData, {
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//     });
//   };
// const quickAxiosInstanceWithSmallLoadPost: QuickPostFunction = async function (
//   url: string,
//   formData: FormData | Record<string, any>
// ) {
//   return axiosInstanceWithSmallLoad.post(url, formData, {
//     headers: {
//       "Content-Type": "application/x-www-form-urlencoded",
//     },
//   });
// };

const getAxiosBaseInstanceFile = async function (url: string) {
  return axiosBaseInstance.get(url, {
    responseType: "blob",
  });
};
const getAxiosBaseInstanceWithoutMaskFile = async function (url: string) {
  return axiosBaseInstanceWithoutMask.get(url, {
    responseType: "blob",
  });
};

// 附加 quickPost 快捷填入 post 表单请求头
const api = {
  request: {
    ...axiosInstance,
    quickPost: quickPostBase("axiosInstance"),
  } as AxiosInstance & { quickPost: QuickPostFunction },

  requestWithoutMask: {
    ...axiosInstanceWithoutMask,
    quickPost: quickPostBase("axiosInstanceWithoutMask"),
  } as AxiosInstance & { quickPost: QuickPostFunction },

  requestBase: {
    ...axiosBaseInstanceWithoutMask,
    quickPost: quickPostBase("axiosBaseInstanceWithoutMask"),
    getfile: getAxiosBaseInstanceFile,
  } as AxiosInstance & {
    quickPost: QuickPostFunction;
    getfile: typeof getAxiosBaseInstanceFile;
  },

  requestBaseWithMask: {
    ...axiosBaseInstance,
    quickPost: quickPostBase("axiosBaseInstance"),
    getfile: getAxiosBaseInstanceWithoutMaskFile,
  } as AxiosInstance & {
    quickPost: QuickPostFunction;
    getfile: typeof getAxiosBaseInstanceWithoutMaskFile;
  },

  requestWithSmallLoad: {
    ...axiosInstanceWithSmallLoad,
    quickPost: quickPostBase("axiosInstanceWithSmallLoad"),
  } as AxiosInstance & {
    quickPost: QuickPostFunction;
  },

  login: login,
};
export default api;
